/**
 * Mega Menu Functionality
 *
 * Handles multiple independent mega menus (services + products). Each pair is a
 * [trigger, menu] selector tuple; opening one closes the others.
 */
export default function () {
    const pairs = [
        ['.js-header--service', '.js-mega-menu'],
        ['.js-header--products', '.js-mega-menu--products'],
    ];

    pairs.forEach(([linkSel, menuSel]) => {
        const $link = $(linkSel);
        const $menu = $(menuSel);

        if (!$link.length || !$menu.length) {
            return;
        }

        // Open/close on trigger click
        $link.on('click', function (e) {
            e.preventDefault();

            const isActive = $(this).hasClass('active');
            closeAll(pairs);

            if (!isActive) {
                toggleMegaMenu($(this), $menu);
            }
        });

        // Close button inside this menu
        $menu.find('.js-mega-menu--close').on('click', function (e) {
            e.preventDefault();
            removeMegaMenu($link, $menu);
        });
    });

    // Close any open mega menu when clicking outside of it
    $(document).on('click', function (e) {
        const insideMenu = pairs.some(([, menuSel]) => $(e.target).closest(menuSel).length);
        const insideLink = pairs.some(([linkSel]) => $(e.target).closest(linkSel).length);

        if (!insideMenu && !insideLink) {
            closeAll(pairs);
        }
    });
}

function closeAll(pairs) {
    pairs.forEach(([linkSel, menuSel]) => {
        removeMegaMenu($(linkSel), $(menuSel));
    });
}

function toggleMegaMenu(link, menu) {
    link.addClass('active');
    $('body').addClass('hidden');
    $('body').addClass('mega-menu-open');
    menu.slideDown(400);
}

function removeMegaMenu(link, menu) {
    link.removeClass('active');
    $('body').removeClass('hidden');
    $('body').removeClass('mega-menu-open');
    menu.slideUp(400);
}
